export default function ($api) {
    return {
        getCategory({ slug, id }) {
            let query = "";
            if (slug) {
                query += `?filters[slug][eq]=${slug}`;
            }
            if (id) {
                query += `?filters[id][eq]=${id}`;
            }
            return $api.get(`api/section/one${query}`);
        },
        getCategories(query = "") {
            return $api.get(`api/section/all${query}`);
        },
        getSubCategories(section) {
            const query = `api/section/all?filters[depthLevel][lte]=${
                section.depthLevel + 1
            }&filters[leftMargin][gte]=${section.leftMargin}&filters[rightMargin][lte]=${
                section.rightMargin
            }&sorts[leftMargin]=asc`;

            return $api.get(query);
        },
        getProductsByCategoryId({
            id,
            sorts = "popular",
            page = 1,
            perPage = 28,
            query = "",
        }) {
            const categoriesIds = id ? `&filters[categoriesIds][eq]=${id}` : "";
            const path = `api/product/all?sorts=${sorts}&paging[page]=${page}&paging[per_page]=${perPage}${categoriesIds}&filters[eol][null]=1${query}`;

            return $api.get(path);
        },
        getBreadcrumbs({ mainCategory }) {
            return $api.get(
                `api/section/all?filters[depthLevel][lte]=${mainCategory.depthLevel}&filters[rightMargin][gte]=${mainCategory.rightMargin}&filters[leftMargin][lte]=${mainCategory.leftMargin}&sorts[leftMargin]=asc`
            );
        },
        getSearch({ term, page = 1 }) {
            return $api.get(
                encodeURI(
                    `api/product/search?term=${term}&filters[available][eq]=1&paging[per_page]=30&paging[page]=${page}`
                )
            );
        },
    };
}
